import { useSWRHandler } from "./useSWRHandler"
import { useDeviceSettingsList } from "src/hooks"

export function useDeviceSettingsHandler() {
  return useSWRHandler(useDeviceSettingsList)
}
